import { render, staticRenderFns } from "./SettingPreferencesForm.vue?vue&type=template&id=55e4a4e8&"
import script from "./SettingPreferencesForm.vue?vue&type=script&lang=js&"
export * from "./SettingPreferencesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports